var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPagevisit = function SvgPagevisit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pagevisit_svg__a)",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M19 8h-4a1 1 0 0 1-1-1V3",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19 8h-4a1 1 0 0 1-1-1V3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5 13V5a2 2 0 0 1 2-2h7.172a2 2 0 0 1 1.414.586l2.828 2.828A2 2 0 0 1 19 7.828V19a2 2 0 0 1-2 2h-4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.286,
    d: "M10.247 19.389a2.57 2.57 0 0 1-3.637 0 2.57 2.57 0 0 1 0-3.637 2.572 2.572 0 0 1 3.637 3.637"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9 11h6M13 14h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.286,
    d: "m5 21 1.61-1.611"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pagevisit_svg__a",
    x1: 16.5,
    x2: 16.5,
    y1: 3,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DCE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5DCE1",
    stopOpacity: 0
  })))));
};
export { SvgPagevisit as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYTYyNTczMDgxMjY5MTY2MGQ2MjM2MWJmMzBjMzE5ZGQuc3ZnIjs=";